module.exports = __webpack_public_path__ + "img/plan.bc87cc77.png";